

    <div class="d-flex gx-2-4 mt-2 schedule-preview">
        <div class="text-secondary pe-3">
            <i class="fa-light fa-clock fa-2x"></i>
        </div>
        @if(options){
            <div class="step pe-1">
                <div class="collect-step" [matTooltip]="('poll_creation.schedule_output_desc1_today' | translate) + ' ' + (options.displayStartDate | date: 'fullDate')">
                    {{'poll_creation.schedule_preview.collect' | translate}}
                    @if(options){
                        <div class="date start">
                            @if(isToday(options.displayStartDate)){
                                <div class="label">{{ 'today' | translate }}</div>
                            }@else{
                                <div class="label">{{options.displayStartDate | date }}</div>
                            }
                            <div class="pin"></div>
                        </div>
                        <div class="date end">
                            <div class="label">{{options.displayEndDate | date }}</div>
                            <div class="pin"></div >
                        </div>
                        <div class="date reminder">
                            <div class="label">{{options.reminderDate | date }}<br>{{'poll_creation.schedule_preview.reminder' | translate}}
                            </div>
                            <div class="pin"></div>
                        </div>
                    }
                </div>
        
            </div>
            <div class="step">
                <div class="result-step" [matTooltip]="('poll_creation.schedule_output_desc3' | translate) + ' ' + (options.displayEndDate | date: 'fullDate')">
                    {{'poll_creation.schedule_preview.analyze' | translate}}
                    @if(options){
                        <div class="date results">
                            <div class="label fst-italic">{{'poll_creation.schedule_preview.from' | translate}}<br>{{options.resultPublicationDate | date }}</div>
                            <div class="pin"></div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>

